import { render, staticRenderFns } from "./PageImage.vue?vue&type=template&id=5400569f"
import script from "./PageImage.vue?vue&type=script&lang=js"
export * from "./PageImage.vue?vue&type=script&lang=js"
import style0 from "./PageImage.vue?vue&type=style&index=0&id=5400569f&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports